import { ReactComponent as AlertIcon } from '../assets/icons/main/alertIcon.svg';
import {palette} from '../theme/palette';
import {
    Card,
    CardContent,
    CardHeader,
    DialogTitle,
    Grid,
    TextField,
    Typography,
    Button,
    Stack,
    Box,
  } from '@mui/material';
const ErrorPage = ()=>{
    return(
        <div style={{textAlign:'center', display:'flex', justifyContent:'center', alignItems:'center', height:'80vh', flexDirection:'column'}}>
            <AlertIcon style={{ height: '150px', width: '150px', color : palette.warning.main  }}/>
            <Typography variant='h1' m={5}>Page not found </Typography>
            <Typography> The page you are looking for doesn't exist or an other error occured, please go back or refresh...</Typography>
        </div>
    )
}
export default ErrorPage;